class commonHelper {
    constructor() {
        this.modalVideoDismiss();
    }
    modalVideoDismiss() {
        $('.modal-type-video').each(function(){
            $(this).on('hidden.bs.modal', function(e) {
                var body = $(this).find('.modal-body-video');
                var html = $(body).html();
                $(body).html(html);
            });
        });
    }
    scrollToTop(el) {
        $(el).click(e => {
            e.preventDefault();
            $('body,html').animate({
                scrollTop: 0
            }, 750);
        });
    }
}
window.app.add('common', new commonHelper());


// WEBPACK FOOTER //
// ./_src/js/lib/common.js